export default __webpack_public_path__ + "static/media/h5-pic-bg1.3cf20f1d.png";